import {itemWithoutDiscounts} from './itemWithoutDiscounts';

export const query = `query getSliderGalleryDataWithoutDiscounts($externalId: String!, $compId: String!, $limit: Int!, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    category(compId: $compId) {
      id
      name
      visible
      productsWithMetaData(limit: $limit, onlyVisible: true) {
        list {
          ${itemWithoutDiscounts}
        }
        totalCount
      }
    }
    allProductsCategoryId
  }
}
`;
